(() => {
  const shadeColors = {
    bella:'#CFBAA1',darkcoffee:'#6f4c3c',madeleine:'#B79A78',biscuit:'#D8B985',tone:'#DCC3A8',custard:'#E3C6A2',comma:'#E6D1B8',glaze:'#B58B55',nougat:'#DECCB6',loom:'#A9876B',
    dune:'#D4C4B0',brunette:'#C19E7F',sand:'#E7D6C5',bambi:'#E7CCAF',coco:'#876A5A',cafe:'#8B6843',mellow:'#C19667',bali:'#A27453',honey:'#EDC699',butter:'#E7CDA9',cream:'#E8CEB8',tones:'#D0AC81',praline:'#C0A786',pinky:'#E3CBAB',desert:'#C6A07C',tuscan:'#704A38',seashell:'#D4C4B0',silk:'#E7D6C5',latte:'#D0AC81',
    darksienna:'#731f25',velvetred:'#a71927',blackberrywine:'#5a1b34',taupe:'#84534f',darkcherry:'#720e24',cocoakiss:'#7b4438',truecrimson:'#b2172c',deepburgundy:'#4b1422',pinkpeach:'#c86f6e',twilight:'#624054',dustypear:'#a45d63',outlandish:'#a82943',
    cinnamon:'#9b584d',vermouth:'#8a3d4d',apple:'#b53d38',berrybrown:'#713c46',raspberry:'#9c2947',coffee:'#653e34',tropicalpink:'#d45f72',honeybun:'#a86a55',sablebrown:'#71463d',blackberry:'#4d2735',deepcoral:'#b95d52',
    sienna:'#a55d4b',pearl:'#e8c8b2',chestnut:'#7f4639',rouge:'#ad2e39',shine:'#d3a891',drippinggold:'#c79b61',brick:'#99483b',lavender:'#a77891',mahogany:'#623a32',bare:'#b98473',clear:'#e7d9cf',warmrose:'#b76c72',unbutton:'#A87567',glassslipper:'#F3F1F5',loveletter:'#A45A61',rosewood:'#9f5f61',sheerhotpink:'#d95781',sheerred:'#bf3e47'
  };
  const normalize = value => String(value || '').toLowerCase().replace(/[^a-z0-9]+/g,'');
  const money = cents => {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US',{style:'currency',currency:window.Shopify?.currency?.active || 'USD'}).format((Number(cents)||0)/100); }
    catch { return `$${((Number(cents)||0)/100).toFixed(2)}`; }
  };
  function init(root) {
    if (root.dataset.rnSetReady === 'true') return;
    root.dataset.rnSetReady = 'true';
    const accordionItems = [...root.querySelectorAll('.rn-set-information details')];
    accordionItems.forEach(item => item.addEventListener('toggle', () => {
      if (!item.open) return;
      accordionItems.forEach(other => { if (other !== item) other.open = false; });
    }));
    const form = root.querySelector('.rn-set-builder__form');
    if (!form) return;
    const json = root.querySelector('[data-rn-set-product-json]');
    const variantInput = root.querySelector('[data-rn-set-variant]');
    const price = root.querySelector('[data-rn-set-price]');
    const add = root.querySelector('[data-rn-set-add]');
    const status = root.querySelector('[data-rn-set-status]');
    const image = root.querySelector('.rn-set-builder__product-image');
    const groups = [...root.querySelectorAll('[data-rn-set-option]')];
    let product = {};
    try { product = JSON.parse(json?.textContent || '{}'); } catch {}
    let variants = product.variants || [];
    const selected = groups.map(group => group.querySelector('.is-selected')?.dataset.value || group.querySelector('[data-rn-set-value]')?.dataset.value || '');
    const setImage = source => {
      if (!image || !source) return;
      image.style.opacity = '.25';
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.onload = () => { image.style.opacity = '1'; };
      image.src = source;
    };

    groups.forEach((group, groupIndex) => {
      group.querySelectorAll('[data-rn-set-value]').forEach(button => {
        const key = normalize(button.dataset.value);
        button.style.setProperty('--rn-set-shade', shadeColors[key] || `hsl(${(key.split('').reduce((sum,char)=>sum+char.charCodeAt(0),0)*17)%360} 28% 66%)`);
        button.addEventListener('click', () => {
          selected[groupIndex] = button.dataset.value;
          group.querySelectorAll('[data-rn-set-value]').forEach(item => { const active = item === button; item.classList.toggle('is-selected',active); item.setAttribute('aria-pressed',String(active)); });
          const activeChoice = root.querySelector(`[data-rn-set-active-choice="${groupIndex}"]`);
          const tabChoice = root.querySelector(`[data-rn-set-tab-choice="${groupIndex}"]`);
          if (activeChoice) activeChoice.textContent = button.dataset.value;
          if (tabChoice) tabChoice.textContent = button.dataset.value;
          update();
          if (image && button.dataset.image) {
            setImage(button.dataset.image);
          }
        });
      });
    });

    function variantImage(variant) {
      const featured = variant?.featured_image;
      return typeof featured === 'string' ? featured : featured?.src || variant?.featured_media?.preview_image?.src || '';
    }
    function update() {
      root.querySelectorAll('[data-rn-set-summary-value]').forEach((label,index) => { label.textContent = selected[index] || 'Choose a shade'; });
      if (!groups.length) return;
      const match = variants.find(variant => variant.options?.every((option,index) => String(option) === String(selected[index])));
      if (!match) {
        if (variantInput) variantInput.value = '';
        if (add) {
          add.disabled = true;
          add.querySelector('span').textContent = 'Choose every shade';
        }
        if (status) status.textContent = 'Complete each selection to prepare your Reneora set.';
        return;
      }
      if (variantInput) variantInput.value = match.id;
      if (price) price.textContent = money(match.price);
      if (add) {
        add.disabled = !match.available;
        add.querySelector('span').textContent = match.available ? (add.dataset.defaultLabel || add.querySelector('span').textContent || 'Add Your Set to Bag') : 'Sold out';
      }
      if (status) status.textContent = match.available ? (status.dataset.readyStatus || status.textContent || 'Your Reneora ritual is ready.') : (status.dataset.unavailableStatus || 'This combination is currently unavailable.');
      const nextImage = variantImage(match);
      if (image && nextImage && image.src !== nextImage && !['lip_duo','lip_trio'].includes(root.dataset.setKind)) setImage(nextImage);
    }
    if (add) add.dataset.defaultLabel = add.querySelector('span')?.textContent || 'Add Your Set to Bag';

    let tabs = [...root.querySelectorAll('[data-rn-set-tab]')];
    const save = root.querySelector('[data-rn-set-save]');
    const saveStatus = root.querySelector('[data-rn-set-save-status]');
    const stepOrder = groups.map((group,index) => index);
    if (root.dataset.setKind === 'lip_duo' && tabs.length === 2) {
      const oilIndex = groups.findIndex(group => normalize(group.querySelector('legend')?.dataset.rnOriginalOption || group.querySelector('legend strong')?.textContent).includes('oil'));
      if (oilIndex > 0) {
        stepOrder.splice(oilIndex,1);
        stepOrder.unshift(oilIndex);
        const tabHost = root.querySelector('.rn-lip-builder__tabs');
        const plus = tabHost?.querySelector(':scope > i');
        const orderedTabs = stepOrder.map(index => tabs.find(tab => Number(tab.dataset.rnSetTab) === index)).filter(Boolean);
        if (tabHost && orderedTabs.length === 2) tabHost.replaceChildren(orderedTabs[0],plus,orderedTabs[1]);
        tabs = orderedTabs;
      }
    }
    stepOrder.forEach((groupIndex,position) => {
      const number = groups[groupIndex]?.querySelector('legend > span');
      if (number) number.textContent = String(position + 1).padStart(2,'0');
    });
    let activeStep = 0;
    const savedSteps = new Set();
    let continueMode = false;
    const showStep = index => {
      activeStep = Math.max(0,Math.min(index,groups.length - 1));
      const groupIndex = stepOrder[activeStep];
      tabs.forEach((tab,tabIndex) => { const active = tabIndex === activeStep; tab.classList.toggle('is-active',active); tab.setAttribute('aria-selected',String(active)); });
      groups.forEach((group,index) => group.classList.toggle('is-active',index === groupIndex));
      const visual = root.querySelector('.rn-set-builder__visual');
      const optionData = product.options?.[groupIndex];
      const optionName = normalize((typeof optionData === 'string' ? optionData : optionData?.name) || groups[groupIndex]?.querySelector('legend strong')?.textContent);
      const selectedButton = groups[groupIndex]?.querySelector('.is-selected[data-image]');
      const activeAsset = selectedButton?.dataset.image || (optionName.includes('liner') ? visual?.dataset.rnLipImageLiner : optionName.includes('oil') ? visual?.dataset.rnLipImageOil : visual?.dataset.rnLipImageStain);
      if (image && activeAsset) setImage(activeAsset);
      if (save) save.querySelector('span').textContent = continueMode && activeStep === groups.length - 1 ? (save.dataset.continueLabel || 'Continue to Your Duo') : (save.dataset.saveLabel || 'Save This Shade');
    };
    tabs.forEach((tab,index) => tab.addEventListener('click',()=>showStep(index)));
    if (tabs.length) showStep(0);
    save?.addEventListener('click',()=>{
      if (continueMode && activeStep === groups.length - 1) {
        root.querySelector('.rn-set-builder__summary')?.scrollIntoView({behavior:'smooth',block:'start'});
        return;
      }
      savedSteps.add(activeStep);
      tabs[activeStep]?.classList.add('is-saved');
      if (activeStep < groups.length - 1) {
        const savedName = selected[stepOrder[activeStep]] || 'Your shade';
        showStep(activeStep + 1);
        if (saveStatus) saveStatus.textContent = `${savedName} ${save.dataset.nextStatus || 'is saved. Continue with your next essential.'}`;
      } else {
        continueMode = savedSteps.size === groups.length;
        if (saveStatus) saveStatus.textContent = save.dataset.completeStatus || `Your ${groups.length} shades are saved. Continue to your complete ritual below.`;
        showStep(activeStep);
      }
    });

    const handle = root.dataset.productHandle;
    if (handle && groups.length) {
      fetch(`${window.Shopify?.routes?.root || '/'}products/${handle}.js`)
        .then(response => response.ok ? response.json() : Promise.reject())
        .then(fullProduct => { if (fullProduct?.variants?.length) variants = fullProduct.variants; update(); })
        .catch(() => update());
    } else update();
  }
  const initAll = scope => scope.querySelectorAll('[data-rn-set-product]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>initAll(document),{once:true}); else initAll(document);
  document.addEventListener('shopify:section:load',event=>initAll(event.target));
})();
